import {IFeatureFlagConfig} from "@pg-mono/amplitude";

export enum RpFeatureFlag {}

export const rpFeatureFlags: IFeatureFlagConfig[] = [];
import {IFeatureFlagConfig} from "@pg-mono/amplitude";

export enum RpFeatureFlag {}

export const rpFeatureFlags: IFeatureFlagConfig[] = [];
